import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { locationInfo } from '../mockData';

const Location = () => {
  return (
    <section id="ubicacion" className="section location-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Ubicación y Contacto</h2>
          <p className="section-description">
            Visítanos o contáctanos, estamos para servirte
          </p>
        </div>

        <div className="location-content">
          {/* Información de contacto */}
          <div className="location-info">
            <div className="location-info-card">
              <div className="location-info-icon">
                <MapPin size={24} />
              </div>
              <div>
                <h3 className="location-info-title">Dirección</h3>
                <p className="location-info-text">{locationInfo.address}</p>
              </div>
            </div>

            <div className="location-info-card">
              <div className="location-info-icon">
                <Phone size={24} />
              </div>
              <div>
                <h3 className="location-info-title">Teléfono</h3>
                <p className="location-info-text">{locationInfo.phone}</p>
              </div>
            </div>

            <div className="location-info-card">
              <div className="location-info-icon">
                <Mail size={24} />
              </div>
              <div>
                <h3 className="location-info-title">Email</h3>
                <p className="location-info-text">{locationInfo.email}</p>
              </div>
            </div>

            <div className="location-info-card">
              <div className="location-info-icon">
                <Clock size={24} />
              </div>
              <div>
                <h3 className="location-info-title">Horarios</h3>
                <p className="location-info-text" style={{ whiteSpace: 'pre-line' }}>
                  {locationInfo.hours}
                </p>
              </div>
            </div>
          </div>

          {/* Mapa */}
          <div className="location-map">
            <iframe
              src={locationInfo.mapUrl}
              width="100%"
              height="100%"
              style={{ border: 0, borderRadius: '12px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación SSF"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
